export default function ImportsPage() {
  return (
    <div className="container mx-auto p-6 max-w-2xl">
      <h1 className="text-2xl font-bold text-gray-900">Imports</h1>
      <p className="mt-2 text-sm text-gray-500">Reserved admin utility route for batch import workflow.</p>
      <div className="mt-4 rounded-xl border border-gray-200 bg-white p-4 text-sm text-gray-700">
        Import tools are not active in this runtime build.
      </div>
    </div>
  )
}
